/**
 * @name Funds Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/funds`;

export const byId = `${base}`;
export const updateById = `${base}`;
export const newFund = `${base}`;
export const fundById = (fundId: number) => `${base}/${fundId}`;
export const getMeasurementDateByFundId = (fundId: string) => `${base}/measurement-dates/funds/${fundId}`;
export const createCompanyForMeasurementDate = (mpId: string) => `${base}/measurement-dates/${mpId}/company`;
export const addCompanyToMeasurementDate = `${API.BASE_DEV_HOST}/fund-companies`;
export const getFundSummaryByMD = (fundId: string, mdId: string) => `${base}/${fundId}/summary?md=${mdId}`;
export const getFundInvestmentByMD = (fundId: string, mdId: string, checkForExport: boolean) =>
  `${base}/${fundId}/investments?md=${mdId}&export=${checkForExport}`;
export const getFundAllocationsByMD = (fundId: string, mdId: string) => `${base}/${fundId}/allocations?md=${mdId}`;
export const getCompaniesByFundId = (fundId: number) => `${base}/${fundId}/companies/`;
